import { c as _c } from "react/compiler-runtime";
/* istanbul ignore file */
import { Fragment, ReactNode } from 'react';
export interface Props {
  children: ReactNode;
  count: number;
}

/* istanbul ignore next */
const Repeat = t0 => {
  const $ = _c(7);
  const {
    children,
    count: t1
  } = t0;
  const count = t1 === undefined ? 1 : t1;
  let t2;
  if ($[0] !== children || $[1] !== count) {
    let t3;
    if ($[3] !== children) {
      t3 = (_, rowIndex) => <Fragment key={rowIndex}>{children}</Fragment>;
      $[3] = children;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = Array(Math.max(0, count)).fill(null).map(t3);
    $[0] = children;
    $[1] = count;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <>{t2}</>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default Repeat;